import { createTheme } from '@mui/material';

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        footer: {
            background: '#111827',
            text: '#B0BEC5',
        },
        background: {
            default: '#111828', // Azul oscuro, más acorde con tus gustos
            paper: '#202938', // Fondo ligeramente más claro para el papel #0b1f2a
            card: '#03112a',
            darkCard: '#03112a',
            light: '#384152', // Gris más claro para el fondo de los componentes
            darkContrast: '#384152',
        },
        navigation: {
            main: '#111828',
        },
        border: {
            light: 'rgba(255, 255, 255, 0.05)',
            main: 'rgba(255, 255, 255, 0.1)',
            dark: 'rgba(255, 255, 255, 0.15)',
            darkerLight: 'rgba(255, 255, 255, 0.25)',
            darker: 'rgba(255, 255, 255, 0.5)',
            accent: '#50109e',
            accent2: '#bb86fc',
            accent3: '#FF0080',
        },
        primary: {
            main: '#2196F3', // Azul vivo, buena visibilidad en dark mode
            light: '#64B5F6', // Azul claro, pero que sigue siendo visible sobre fondo oscuro
            dark: '#1976D2', // Azul más profundo para dar buen contraste
            contrastText: '#fff', // Texto blanco para buena lectura sobre los azules
        },
        secondary: {
            main: '#26C6DA', // Un azul más fuerte
            light: '#4DD0E1',
            dark: '#0097A7',
        },
        tertiary: {
            main: '#FF5722',
            light: '#FF7043',
            dark: '#E64A19',
        },
        accent: {
            main: '#50109e', // Morado profundo
            light: '#7C4DFF', // Morado claro
            dark: '#311B92', // Morado oscuro
            contrastText: '#fff',
        },
        accent2: {
            main: '#bb86fc', // Púrpura/Lila claro
            light: '#E1BEE7', // Lila muy claro
            dark: '#9C27B0', // Púrpura oscuro
            contrastText: '#000',
        },
        accent3: {
            main: '#FF0080', // Rosa/Magenta
            light: '#FF4081', // Rosa claro
            dark: '#C51162', // Rosa oscuro
            contrastText: '#fff',
        },
        text: {
            primary: '#B0BEC5',
            secondary: '#8b969b', // Gris claro para el texto secundario
            disabled: '#ffffff33',
        },
        success: {
            main: '#66BB6A',
            light: '#A5D6A7',
            dark: '#388E3C',
        },
        error: {
            main: '#EF5350',
            light: '#E57373',
            dark: '#D32F2F',
        },
        warning: {
            main: '#FFA726',
            light: '#FFB74D',
            dark: '#F57C00',
        },
        info: {
            main: '#29B6F6',
            light: '#4FC3F7',
            dark: '#0288D1',
        },
        divider: '#37474F', // Gris más oscuro para los divisores
        competitions: {
            laLiga: '#ff4b44',
            fifaFriendlies: '#4db7ad',
            championsLeague: '#1d6fb1',
            supercopaEspaña: '#F66A03',
            copaRey: 'rgb(229 184 105)',
            europaLeague: '#1a892d',
            euroClasificacion: '#158ec0',
            defaultColor: '#69b59f',
        },
        navbar: {
            default: '#0A1F2A', // Azul oscuro, más acorde con tus gustos
            paper: '#102940', // Fondo ligeramente más claro para el papel
            border: '#0A1F2A',
            text: '#FFFFFF',
        },
        analitica: {
            main: '#0a1f2a',
            contrastText: '#fff',
        },
        risks: {
            veryHigh: 'rgb(242 127 127)',
            high: 'rgb(208 172 108)',
            medium: '#dddddd',
            low: 'rgb(148 191 148)',
            veryLow: 'rgb(192 216 237)',
        },
        minutes: {
            veryHigh: '#2196f3',
            high: '#0C6',
            medium: '#ccc',
            low: '#F90',
            veryLow: '#d32f2f',
        },
        competitions: {
            laLiga: '#ff4b44',
            fifaFriendlies: '#4db7ad',
            championsLeague: '#1d6fb1',
            supercopaEspaña: '#F66A03',
            copaRey: 'rgb(229 184 105)',
            europaLeague: '#1a892d',
            euroClasificacion: '#158ec0',
            defaultColor: '#69b59f',
        },
    },
    boxShadows: {
        main: '0px 0px 10px 0px rgba(255, 255, 255, 0.08)',
        hover: '0px 0px 12px 0px rgba(255, 255, 255, 0.15)',
        active: '0px 0px 14px 0px rgba(255, 255, 255, 0.25)',
        disabled: '0px 0px 8px 0px rgba(255, 255, 255, 0.05)',
        selected: '0px 0px 16px 0px rgba(255, 255, 255, 0.3)',
    },
    gradient: {
        main: 'linear-gradient(90deg, #0a0a0a 0%, #1a2f4a 60%, transparent 100%)',
        secondary: 'linear-gradient(90deg, #0a0a0a 0%, #5a1a3a 60%, transparent 100%)',
    },
    info: {
        success: '#1e4620', // verde oscuro elegante
        warning: '#663c00', // ámbar oscuro
        error: '#5f2120', // rojo oscuro vino
        info: '#0b3954', // azul oscuro profundo
        default: '#2c3e50', // gris-azul neutro para fondo general
    },
    mercado: {
        up: '#6bd37d',
        down: '#f98383',
        default: '#ccc',
    },
    resultados: {
        win: '#1a572e9e',
        draw: '#d5c0505e',
        lose: '#9434348f',
    },
    resultadosBox: {
        win: 'rgb(0, 121, 61)',
        draw: 'rgb(212, 90, 0)',
        lose: 'rgb(186, 59, 59)',
    },
    tier: {
        tier1: '#ff4b44',
        tier2: '#4CAF50',
        tier3: '#1a892d',
        tier4: '#158ec0',
        tier5: '#1d6fb1',
        tier6: '#4db7ad',
        tier7: '#69b59f',
    },
    typography: {
        allVariants: {
            fontFamily: `'Barlow', sans-serif`,
            textTransform: 'none',
            fontSize: 16,
            color: '#B0BEC5',
            lineHeight: 1.5,
        },
        h1: {
            fontSize: '20px',
            fontWeight: 500,
            color: '#B0BEC5',
            marginBottom: '1rem',
            lineHeight: 1.2,
        },
        h2: {
            fontSize: '19px',
            fontWeight: 500,
            color: '#B0BEC5',
        },
        h3: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#B0BEC5',
        },
        h4: {
            fontSize: '17px',
            fontWeight: 500,
            color: '#B0BEC5',
        },
        h5: {
            fontSize: '16px',
            fontWeight: 500,
            color: '#B0BEC5',
        },
        h6: {
            fontSize: '15px',
            fontWeight: 500,
            color: '#B0BEC5',
        },
        body1: {
            color: '#B0BEC5',
        },
        body2: {
            color: '#B0BEC5',
        },
    },
    components: {
        MuiTableRow: {
            styleOverrides: {
                root: ({ theme }) => ({
                    transition: 'background-color 0.3s ease',
                    '&:hover': {
                        backgroundColor: 'rgba(76, 175, 80, 0.15)', // verde más visible en dark mode
                        cursor: 'pointer',
                    },
                    border: `1px solid ${theme.palette.border.light}`,
                }),
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderBottom: `1px solid ${theme.palette.border.light}`,
                }),
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.darkCard,
                }),
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.default,
                }),
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: ({ theme }) => ({
                    position: 'relative',
                    border: `1px solid ${theme.palette.border.light}`,
                    borderRadius: '8px',
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        height: '3px',
                        background:
                            'linear-gradient(90deg, #69b59f 0%, rgba(105, 181, 159, 0.25) 60%, transparent 100%)',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        pointerEvents: 'none',
                        zIndex: 1,
                    },
                }),
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '--Paper-shadow': 'none',
                    '--Paper-overlay': 'none',
                    boxShadow: 'none',
                    backgroundImage: 'none',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
            variants: [
                // Accent color variants
                {
                    props: { variant: 'contained', color: 'accent' },
                    style: ({ theme }) => ({
                        backgroundColor: theme.palette.accent.main,
                        color: theme.palette.accent.contrastText,
                        '&:hover': {
                            backgroundColor: theme.palette.accent.dark,
                        },
                        '&:active': {
                            backgroundColor: theme.palette.accent.dark,
                        },
                    }),
                },
                {
                    props: { variant: 'outlined', color: 'accent' },
                    style: ({ theme }) => ({
                        borderColor: theme.palette.accent.main,
                        color: theme.palette.accent.main,
                        '&:hover': {
                            borderColor: theme.palette.accent.dark,
                            backgroundColor: `${theme.palette.accent.main}14`,
                        },
                    }),
                },
                {
                    props: { variant: 'text', color: 'accent' },
                    style: ({ theme }) => ({
                        color: theme.palette.accent.main,
                        '&:hover': {
                            backgroundColor: `${theme.palette.accent.main}14`,
                        },
                    }),
                },
                // Accent2 color variants
                {
                    props: { variant: 'contained', color: 'accent2' },
                    style: ({ theme }) => ({
                        backgroundColor: theme.palette.accent2.main,
                        color: theme.palette.accent2.contrastText,
                        '&:hover': {
                            backgroundColor: theme.palette.accent2.dark,
                        },
                        '&:active': {
                            backgroundColor: theme.palette.accent2.dark,
                        },
                    }),
                },
                {
                    props: { variant: 'outlined', color: 'accent2' },
                    style: ({ theme }) => ({
                        borderColor: theme.palette.accent2.main,
                        color: theme.palette.accent2.main,
                        '&:hover': {
                            borderColor: theme.palette.accent2.dark,
                            backgroundColor: `${theme.palette.accent2.main}14`,
                        },
                    }),
                },
                {
                    props: { variant: 'text', color: 'accent2' },
                    style: ({ theme }) => ({
                        color: theme.palette.accent2.main,
                        '&:hover': {
                            backgroundColor: `${theme.palette.accent2.main}14`,
                        },
                    }),
                },
                // Accent3 color variants
                {
                    props: { variant: 'contained', color: 'accent3' },
                    style: ({ theme }) => ({
                        backgroundColor: theme.palette.accent3.main,
                        color: theme.palette.accent3.contrastText,
                        '&:hover': {
                            backgroundColor: theme.palette.accent3.dark,
                        },
                        '&:active': {
                            backgroundColor: theme.palette.accent3.dark,
                        },
                    }),
                },
                {
                    props: { variant: 'outlined', color: 'accent3' },
                    style: ({ theme }) => ({
                        borderColor: theme.palette.accent3.main,
                        color: theme.palette.accent3.main,
                        '&:hover': {
                            borderColor: theme.palette.accent3.dark,
                            backgroundColor: `${theme.palette.accent3.main}14`,
                        },
                    }),
                },
                {
                    props: { variant: 'text', color: 'accent3' },
                    style: ({ theme }) => ({
                        color: theme.palette.accent3.main,
                        '&:hover': {
                            backgroundColor: `${theme.palette.accent3.main}14`,
                        },
                    }),
                },
            ],
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#64B5F6',
                    textDecoration: 'none',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    a: {
                        color: '#64B5F6',
                        textDecoration: 'none',
                    },
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    paddingLeft: '4px',
                    paddingRight: '4px',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#111828',
                    color: '#B0BEC5',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#111828',
                    color: '#B0BEC5',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#111828',
                    color: '#B0BEC5',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    backgroundColor: '#111828',
                    color: '#B0BEC5',
                },
            },
        },
    },
});
